export enum products {
  autopredict = 1,
  pricemytruck = 6,
  instantval = 2,
  salvageval = 11,
  assessval = 12
}